import buildLinkObj, { getRel } from '@repo/ui/src/functions/build-link';

export interface LinkProps {
  link?: {
    label?: string;
    isAnchorLink?: boolean;
    anchorId?: string;
    displayName?: string;
  };
}

interface Props {
  navLinks?: Array<LinkProps>;
  className?: string;
}

const NavLinks = ({ navLinks, className }: Props) => (
  <div className={className}>
    {navLinks?.map(({ link }, i) => {
      const linkObj = buildLinkObj(link);
      const handleNavButtonClick = (anchorId?: string) => {
        const stickyNavBar = 'stickyNavBar';
        const anchorElement = document?.querySelector(`#${anchorId}`) || null;
        const stickyNavBarHeight =
          document?.querySelector<HTMLElement>(`#${stickyNavBar}`)?.offsetHeight || 0;
        const top = anchorElement?.getBoundingClientRect()?.top ?? 0;

        const y = top + window.scrollY - stickyNavBarHeight - 120;

        window.scrollTo({ top: y, behavior: 'smooth' });
      };

      return link?.isAnchorLink ? (
        <button
          type="button"
          aria-label={link?.label || 'Scroll to page section below'}
          key={i}
          onClick={() => handleNavButtonClick(link?.anchorId)}
          className="tra-text-web-sub-3 tw-text-neutral-50 tw-p-4 hover:tw-text-brand-200 tw-transition-colors tw-duration-300"
        >
          {link.displayName}
        </button>
      ) : (
        <a
          rel={getRel(linkObj)}
          key={i}
          href={linkObj.href}
          aria-label={link?.label || 'Link to another page'}
          className="tra-text-web-sub-3 tw-text-neutral-50 tw-p-4 hover:tw-text-brand-200 tw-transition-colors tw-duration-300"
        >
          <div>{linkObj.text}</div>
        </a>
      );
    })}
  </div>
);

export default NavLinks;